module.exports = __webpack_public_path__ + "img/SAVINGSTRUST1.c8ef407d.1eb9be0e.png";